export const purple50 = "#ebebf8";
export const purple100 = "#e0e3f5";
export const purple200 = "#c1c7ec";
export const purple300 = "#a3abe3";
export const purple400 = "#848fda";
export const purple500 = "#6673d1";
export const purple600 = "#5961c7";
export const purple700 = "#4c50be";
export const purple800 = "#3f3fb5";
export const purple900 = "#322eab";
export const purple1000 = "#14148c";
export const purpleA100 = "#b7cff5";
export const purpleA200 = "#99ace8";
export const purpleA400 = "#3339ba";
export const purpleA500 = "#080994";
export const purpleA1000 = "#232848";
